/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import { goBack } from 'connected-react-router'
import editNombreCentreActions, {
    editNombreCentreTypes,
} from '../../../redux/nombreCentreFormationsPrivees/editNombreCentrePrive'
import getAllPrivateCentreActions from '../../../redux/nombreCentreFormationsPrivees/getAllPrivateCenters'
import { Put } from '../../../serveur/axios'

function* editNombreCentreSagas({ response }) {
    try {
        const res = yield Put(
            `collect_data/private_training_center/${response.id}`,
            response
        )

        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    editNombreCentreActions.editNombreCentreSuccess(res.data)
                ),
                yield put(
                    getAllPrivateCentreActions.getAllPrivateCentersRequest()
                ),
                yield put(goBack()),
            ])
        } else {
            yield put(editNombreCentreActions.editNombreCentreFailure(res))
        }
    } catch (error) {
        yield put(editNombreCentreActions.editNombreCentreFailure(error))
    }
}

export function* editNombreCentreSaga() {
    yield takeLatest(
        editNombreCentreTypes.EDIT_NOMBRE_CENTRE_REQUEST,
        editNombreCentreSagas
    )
}
